<template>
<div class="chapter">
<div class="inner_page">
<div class="img_container1a">
<img alt="images" src="images/pg3_a.jpg"/>
</div>
<h1 class="toc-title">Contents</h1><a id="page3">
</a><h2 class="toc-fm"><a id="page3"></a><a href="#/xhtml/Acknowledgement">Acknowledgements</a></h2>
<h2 class="toc-fm"><a href="#/xhtml/Introduction">Introduction</a></h2>
<h2 class="toc-ch"><a href="#/xhtml/Chapter01"><span class="spacet">Chapter 1</span> Project Origins</a></h2>
<h2 class="toc-ch1"><a href="#/xhtml/Chapter02"><span class="spacet">Chapter 2</span> On the Drawing Board</a></h2>
<h2 class="toc-ch1"><span href="#/xhtml/Chapter03" title="Link target outside of Sample"><span class="spacet">Chapter 3</span> Early Days</span></h2>
<h2 class="toc-ch1"><span href="#/xhtml/Chapter04" title="Link target outside of Sample"><span class="spacet">Chapter 4</span> Rivals in the Skies</span></h2>
<h2 class="toc-ch1"><span href="#/xhtml/Chapter05" title="Link target outside of Sample"><span class="spacet">Chapter 5</span> Around the World</span></h2>
<h2 class="toc-ch1"><span href="#/xhtml/Chapter06" title="Link target outside of Sample"><span class="spacet">Chapter 6</span> Development</span></h2>
<h2 class="toc-ch1"><span href="#/xhtml/Chapter07" title="Link target outside of Sample"><span class="spacet">Chapter 7</span> Enter the Supers</span></h2>
<h2 class="toc-ch1"><span href="#/xhtml/Chapter08" title="Link target outside of Sample"><span class="spacet">Chapter 8</span> In the Navy - and Beyond!</span></h2>
<h2 class="toc-ch1"><span href="#/xhtml/Chapter09" title="Link target outside of Sample"><span class="spacet">Chapter 9</span> The L-1049H</span></h2>
<h2 class="toc-ch1"><span href="#/xhtml/Chapter10" title="Link target outside of Sample"><span class="spacet">Chapter 10</span> Constellation Swansong - The Starliner</span></h2>
<h2 class="toc-ch1"><span href="#/xhtml/Chapter11" title="Link target outside of Sample"><span class="spacet">Chapter 11</span> Genocide that was Biafra</span></h2>
<h2 class="toc-ch1"><span href="#/xhtml/Chapter12" title="Link target outside of Sample"><span class="spacet">Chapter 12</span> Last of the Summer Wine</span></h2>
<h2 class="toc-ch1"><span href="#/xhtml/Appendix01" title="Link target outside of Sample"><span class="spacet">Apprendix I</span> Variants</span></h2>
<h2 class="toc-ch1"><span href="#/xhtml/Appendix02" title="Link target outside of Sample"><span class="spacet">Apprendix II</span> Survivors</span></h2>
<h2 class="toc-bm"><span href="#/xhtml/Bibliography" title="Link target outside of Sample">Bibliography</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?e6cd9250